import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { MENU_HOME_SVG_ICON } from '../../../constants/logo';
import { MenuService } from '../../../services/menu.service';
import { Subscription } from 'rxjs';
import { getLocalStorage } from '../../../utils/storage';
import { keyStorage } from '../../../constants/storage';
import { ActionReducerMapType } from '../../../store/config-reducers';
import { createSelector, select, Store } from '@ngrx/store';
import { AppSettingReducerType } from '../../../store/reducers/app-setting.reducer';
import { appVersion, androidVersion, iosVersion } from '../../../constants/app-version';
import { Platform } from '@ionic/angular';

import { MessageApi } from '../../../api/message-api.service';
import { SetNotiBadge } from '../../../store/actions/profile.action';

const selectReducer = (state: ActionReducerMapType) => {
    return state;
};
const selectAppSettingReducer = createSelector(selectReducer, (state) => {
    return state.appSettingReducer;
});

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
    // menu: MenuSidebar;
    menuSidebar: MenuSidebarType = {
        user: [],
        admin: [],
        other: [],
    };
    subscription: Subscription;
    menuHomeIcon: string = MENU_HOME_SVG_ICON;
    activeMenuId = '0';
    appSettingTextSizeClass: AppSettingReducerType['textSizeInfo']['class'];

    constructor(
        private menuService: MenuService,
        private router: Router,
        private store: Store<ActionReducerMapType>,
        private changeRef: ChangeDetectorRef,
        private platform: Platform,
        public messageApi: MessageApi
    ) {
        this.store.pipe(select(selectAppSettingReducer)).subscribe((state) => {
            this.appSettingTextSizeClass = state.textSizeInfo.class;
        });
    }

    ngOnInit() {}

    ngDoCheck() {
        const isAdmin = `${getLocalStorage(keyStorage.isAdmin)}` === '1';

        this.subscription = this.router.events.subscribe(
            async (event: Event) => {
                if (event instanceof NavigationEnd) {
                    if (this.router.url === '/') {
                        this.activeMenuId = '0';
                    }
                    this.menuSidebar.admin.forEach((menu) => {
                        if (menu.path === this.router.url) {
                            this.activeMenuId = menu.id;
                        }
                    });
                    this.menuSidebar.other.forEach((menu) => {
                        if (menu.path === this.router.url) {
                            this.activeMenuId = menu.id;
                        }
                    });
                    this.menuSidebar.user.forEach((menu) => {
                        if (menu.path === this.router.url) {
                            this.activeMenuId = menu.id;
                        }
                    });
                }
            }
        );
        this.menuService.getMenuSidebar().subscribe((result) => {
            const menuByPermission = getLocalStorage(keyStorage.menuKey);

            const filterAdmin = !isAdmin
                ? []
                : result.admin?.filter((data) =>
                      menuByPermission?.includes(data.id)
                  ) ?? [];

            const filterOther =
                result.other?.filter(
                    (data) =>
                        menuByPermission?.includes(data.id) ||
                        data.id === 'custom_id_manual' ||
                        data.id === 'custom_id_download_mobile'
                ) ?? [];

            const filterUser = isAdmin
                ? []
                : result.user?.filter((data) =>
                      menuByPermission?.includes(data.id)
                  ) ?? [];
            this.menuSidebar = {
                admin: [...filterAdmin],
                other: [...filterOther],
                user: [...filterUser],
            };
            this.changeRef.detectChanges();
        });
    }

    loadNotify = async () => {
        try{
            const data: InboxResponseType[] = await this.messageApi.getMessage();
            if (data) {
                const badge = data.filter((item) => !item.isRead).length;
                this.store.dispatch(SetNotiBadge({ badge }));
            }
        }
        catch(ex){
            console.error("Error : loadNotify : ", ex.message)
        }
        
    }

    onClickHomeMenu = async() => {
        this.loadNotify();
        this.router.navigateByUrl('/');
        this.activeMenuId = '0';
    }

    onClickMenu = (item) => {
        this.router.navigateByUrl(item.path);
        this.activeMenuId = item.id;
    };
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    get appVersionNumber() {
        let vNumber = '';
        const isDesktop = this.platform.is('desktop');
        const isMobile = this.platform.is('mobile');
        const isAndroid = this.platform.is('android');
        const isIos = this.platform.is('ios');
        if (isDesktop) {
            vNumber = appVersion;
        } else if (isMobile) {
            if (isAndroid) {
                vNumber = androidVersion;
            } else if (isIos) {
                vNumber = iosVersion;
            }
        }
        return vNumber;
    }
}
